import React, { useEffect } from 'react';
import { styled } from 'linaria/react';
import { useTracker } from '@jetshop/core/analytics/Analytics';
import { trackListEvent } from '@jetshop/core/analytics/tracking';
import { AddonProduct } from './AddonProduct';
import AddonProductQuery from './AddonProductQuery.gql';
import { useQuery } from 'react-apollo';
import { theme } from '../../Theming/Theming';
import { ScrollBox } from '../../ui/ScrollBox';

const AddonWrapper = styled('div')`
  margin: 1rem 0 1rem 0;
  width: 100%;
  > h3 {
    margin: 1rem 0;
  }
  //SLIDER WIDTH
  .slider-items {
    > * {
      margin-right: 5%;
      ${theme.only.sm} {
        width: 50%;
      }
      ${theme.only.md} {
        width: 50%;
      }
      ${theme.only.lg} {
        width: 40%;
      }
      ${theme.above.xl} {
        width: 40%;
      }
    }
  }
`;

const AddonProductRender = ({ list, accessories }) => {
  const result = useQuery(AddonProductQuery, {
    variables: { articleNumbers: list },
    errorPolicy: 'all'
  });

  const products = result.data?.products;

  //TRACK LIKE PRODUCTGRID
  const track = useTracker();
  useEffect(() => {
    // Dont track anything if there are no products to render
    if (!products || products.length === 0) return;
    // Otherwise track a list view event
    track(trackListEvent({ listName: 'Addon products', products }));
  }, [products, track]);

  if (!products) return null;

  return (
    <AddonWrapper id="addon-products">
      <h3>{accessories.title}</h3>
      <div className="addon-products-grid-scroll">
        <ScrollBox>
          {products.map((product, index) => {
            return (
              <AddonProduct product={product} quickBuy={true} key={index} />
            );
          })}
        </ScrollBox>
      </div>
    </AddonWrapper>
  );
};

const AddonProducts = ({ customData }) => {
  const accessories = customData.filter(item => item.key === 'accessories')[0];
  const list = (accessories && accessories.listValues) || [];

  if (list?.length > 0) {
    return <AddonProductRender list={list} accessories={accessories} />;
  }
  return null;
};

export default AddonProducts;
